import { render, staticRenderFns } from "./ButtonFacebook.vue?vue&type=template&id=c7b27100"
import script from "./ButtonFacebook.vue?vue&type=script&lang=js"
export * from "./ButtonFacebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports